import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsCallout from '@/components/DocsCallout'
import DocsExample from '@/components/DocsExample'
// NEW ______________________________________________________________________
import VueNumber from 'vue-number-animation'
import AOS from 'aos'
import 'aos/dist/aos.css'
// import dayjs from 'dayjs'
// import moment from 'moment'
import LitepieDatepicker from 'litepie-datepicker'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import { api, helpers } from './utils'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueEasyLightbox from 'vue-easy-lightbox'

let app = createApp(App)

app.use(store)
app.use(router)
app.use(CoreuiVue)
// app.use(moment)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsCallout', DocsCallout)
app.component('DocsExample', DocsExample)
// NEW ______________________________________________________________________
app.use(VueNumber)
AOS.init({
    duration: 1000,
    once: true
})
app.component('LitepieDatepicker', LitepieDatepicker)
app.component('Multiselect', Multiselect)
app.use(VueLoading, {
    color: "#fff",
    backgroundColor: "#212121",
    loader: "dots",
    height: 100,
    width: 100
})
app.component("Loading", VueLoading)
app.component('EasyDataTable', Vue3EasyDataTable)
app.use(VueSweetalert2)
app.use(VueEasyLightbox)

app.config.globalProperties.$helpers = helpers
app.config.globalProperties.$api = api

app.mount('#app')
